import React from "react";

const LayoutStateContext = React.createContext();
const LayoutDispatchContext = React.createContext();
const HeaderAddBtnContext = React.createContext(null);
const SearchHeaderFieldContext=React.createContext(null);

function layoutReducer(state, action) {
  if (action.type === "TOGGLE_SIDEBAR") {
    return { ...state, isSidebarOpened: !state.isSidebarOpened };
  } else {
    throw new Error(`Unhandled action type: ${action.type}`);
  }
}

function LayoutProvider({ children }) {
  const [state, dispatch] = React.useReducer(layoutReducer, {
    isSidebarOpened: true,
  });
  return (
    <LayoutStateContext.Provider value={state}>
      <LayoutDispatchContext.Provider value={dispatch}>
        {children}
      </LayoutDispatchContext.Provider>
    </LayoutStateContext.Provider>
  );
}

function useLayoutState() {
  const context = React.useContext(LayoutStateContext);
  if (context === undefined) {
    throw new Error("useLayoutState must be used within a LayoutProvider");
  }
  return context;
}

function useLayoutDispatch() {
  const context = React.useContext(LayoutDispatchContext);
  if (context === undefined) {
    throw new Error("useLayoutDispatch must be used within a LayoutProvider");
  }
  return context;
}

export {
  LayoutProvider,
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
  HeaderAddBtnContext,
  SearchHeaderFieldContext
};

// ###########################################################
function toggleSidebar(dispatch) {
  dispatch({
    type: "TOGGLE_SIDEBAR",
  });
}
